import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { DriverModel } from './../../driver/models/driver.model';
import { DriverService } from './../../driver/models/driver.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, Permission } from '../../shared/config';

@Component({
  selector: 'wego-snail-trail-driver-popup',
  template: require('../views/snail-trail-driver-popup.component.html'),
  providers: [DriverService]
})

export class SnailTrailDriverPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  driverList: DriverModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;

  constructor(private driverService: DriverService    
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetDriverList();
    this.driverModal.show();
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetDriverList() {
    this.isLoading = true;
    this.driverService.GetActiveDriverList(this.DataListModel,true, Permission.PR_SANIL_TRAIL_REPORT)
      .subscribe(
      res => {
        this.driverList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(driver: DriverModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ DriverHashID: driver.driverMasterHashId, DriverName: driver.driverName });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetDriverList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail/components/snail-trail-driver-popup.component.ts